import auth from "../Middlewares/auth";

import DashboardIndex from "../../Components/Pages/Dashboard/Index";

export const routes = [
    {
        path    : '/',
        name    : 'home',
        redirect: '/dashboard'
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: DashboardIndex,
        meta: {
            title: "Dashboard",
            menu: 'left',
            icon: 'mdi-view-dashboard',
            middleware: [
                auth
            ],
        }
    }
]
